import { getFirstTwoMonths } from './getFirstTwoMonths.main';

export { getFirstTwoMonths };
